import img6 from '../.././Image/img6.jpg'
import img7 from '../.././Image/img7.PNG'
import img12 from '../.././Image/img12.png'
import img16 from '../.././Image/IMG_3187.PNG'

function Infra() {
    return (
        <>
            <div className="inline-grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 justify-center place-items-center">

                <div className="overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow w-[300px] h-[300px]">
                    <img
                        src={img16}
                        className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                    />
                </div>

                <div className="overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow w-[300px] h-[300px]">
                    <img
                        src={img6}
                        className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                    />
                </div>

                <div className="overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow w-[300px] h-[300px]">
                    <img
                        src={img12}
                        className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                    />
                </div>
<div className="rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-500 w-[300px] h-[300px]">
                    <img src={img7} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />
                </div>

            </div>


            <div className="text-white mx-4 sm:mx-10 md:mx-[80px] font-sans leading-relaxed mt-10 sm:mt-14 md:mt-16">

                <h1 className="text-center text-2xl sm:text-3xl md:text-4xl font-extrabold mb-10 sm:mb-14 md:mb-16 
                    bg-gradient-to-r from-purple-400 to-blue-400 text-transparent bg-clip-text">
                    Design Documentation
                </h1>

                <div className="inline-grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-10">

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                         hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            IT Infrastructure Framework
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            A complete structure defining servers, networks, hardware, storage,
                            and system architecture required for stable business operations.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                         hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Network Infrastructure Manual
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            A guide covering LAN/WAN setup, routing, switching, firewalls,
                            and connectivity standards for secure, uninterrupted communication.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                             hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Data Center Operations Guide
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            Detailed documentation explaining data center layout, server racks,
                            cabling, cooling, power management, and maintenance procedures.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                             hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Infrastructure Deployment Handbook
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            Instructions for deploying servers, applications, and environments
                            with standardized processes, tools, configurations, and security rules.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                         hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            System Architecture Blueprint
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            A high-level map showing how infrastructure components interact —
                            servers, databases, networks, cloud, and on-prem systems.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                             hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Hardware & Asset Management Guide
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            Documentation defining procurement, tracking, lifecycle management,
                            and maintenance of hardware assets.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                         hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Infrastructure Security Standards
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            A rulebook focused on protecting infrastructure through firewalls,
                            access control, segmentation, monitoring, and compliance.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                         hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            IT Operations & Monitoring Manual
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            Contains procedures for system monitoring, incident handling,
                            performance checks, log analysis, and uptime management.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                         hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Disaster Recovery & Business Continuity Plan
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            A strategic guide covering backups, failover systems, emergency actions,
                            and recovery processes for critical infrastructure.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                         hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Hybrid Infrastructure Integration Guide
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            Explains how cloud, on-prem, and virtual environments integrate into a
                            unified, scalable, optimized system.
                        </p>
                    </div>




                </div>

            </div>

        </>
    );
}


export default Infra;